import { render } from "./SignatureDialog.vue?vue&type=template&id=f85c4120"
import script from "./SignatureDialog.vue?vue&type=script&lang=js"
export * from "./SignatureDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__